import React from 'react';
import PropTypes from 'prop-types';
import {
  defineMessages,
  FormattedMessage,
  FormattedHTMLMessage,
  useIntl,
} from 'react-intl';
import classes from './signin-security.scss';
import EnrolledCheckImage from 'static/images/green_checkmark.png';
import { AnchorIntl } from 'components/intl';

const t = defineMessages({
  'two-step-verification.two-step-verification': {
    id: 'two-step-verification.two-step-verification',
    defaultMessage: 'Two-step verification',
    description: 'Title string for the two-step verification section',
  },
  'two-step-verification.enrolled': {
    id: 'two-step-verification.enrolled',
    defaultMessage: 'Enrolled',
    description: 'Label for indicating that the user is enrolled in two-step verification for a product',
  },
  'two-step-verification.reset-for-new-device': {
    id: 'two-step-verification.reset-for-new-device',
    defaultMessage: 'Reset for a new device',
    description: 'Link text for resetting two-step verification for a new device.',
  },
  'two-step-verification.icon-enrolled': {
    id: 'two-step-verification.icon-enrolled',
    defaultMessage: 'checkmark',
    description: 'Hover text to display over the green check icon.',
  },
  'two-step-verification.enrolled-for-products': {
    id: 'two-step-verification.enrolled-for-products',
    defaultMessage: 'You\'re enrolled for {products}.',
    description: 'Information string for the two-step verification section with product list',
  },
});

export const TwoStepVerification = ({resetTfaOnClick, tfaEnrolledList}) => {
  const intl = useIntl();
  return (
    <div>
      <div className="row">
        <div id="two-step-verification-title" className="col-xs-12 sectionTitle">
          <FormattedMessage {...t['two-step-verification.two-step-verification']} />
        </div>
      </div>
      <div id="two-step-enrolled-information" className={classes['sectionInfo']}>
        <FormattedHTMLMessage
          {...t['two-step-verification.enrolled-for-products']}
          values={{products: tfaEnrolledList}} />
      </div>
      <div id="two-step-enrolled-indicator" className="row">
        <div className="col-xs-2">
          <img
            className={classes['enrolledImage']}
            src={EnrolledCheckImage}
            title={intl.formatMessage(t['two-step-verification.icon-enrolled'])}
            alt=""
          />
        </div>
        <div className="col-xs-10 no-padding">
          <div className={classes['linkLabel']}>
            <FormattedMessage {...t['two-step-verification.enrolled']} />
          </div>
          <div className={classes['actionLink']}>
            <AnchorIntl
              a={{
                href: resetTfaOnClick,
                message: t['two-step-verification.reset-for-new-device'],
                target: '_self'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

TwoStepVerification.propTypes = {
  resetTfaOnClick: PropTypes.string.isRequired,
  tfaEnrolledList: PropTypes.string.isRequired,
};

export default TwoStepVerification;
